import { Expose } from "class-transformer";
import dayjs from "dayjs";

export default class Contact {
  @Expose() contents: object;
  @Expose() status: string;

  @Expose({ name: "created_at" })
  createdAtStr: string;
  @Expose({ name: "form_idef" })
  formIdef: string;
  @Expose({ name: "contact_idef" })
  contactIdef: string;
  @Expose({ name: "contact_type" })
  contactType: string;

  @Expose({ name: "created_at" })
  get createdAt() {
    return dayjs(Number(this.createdAtStr) * 1000).format("YYYY/MM/DD HH:mm");
  }
}
